 <div class="has-pos-rel" [formGroup]="parentFormGroup">
    <label style="z-index: 1;">{{label}}</label>
    <ion-range-slider #sliderElement style="z-index: 0;"
    [ngClass]="modifiyingClass"
    type="double"
    [from]="initialMin"
    [to]="initialMax"
    from_shadow="true"
    to_shadow="true"
    decorate_both="false"
    [values]="values"
    min_interval="2"
    force_edges="true"
    (onFinish)="rangeChanged($event)"
    (onChange)="onChange($event)"
    prettify_enabled="true"
    [prettify]="toMagnitudes"
    prettify_separator=","
    [disable]="disabled"
    hide_min_max="false"
></ion-range-slider>
 </div>

